import { useEffect, useRef, useState, type FormEvent } from "react";

interface Message {
  id: number;
  user: string;
  text: string;
  self?: boolean;
}

const initialMessages: Message[] = [
  { id: 1, user: "峡谷观察员", text: "这波团战太精彩了，打野进场时机绝了！" },
  { id: 2, user: "深夜蹲直播", text: "主播声音好听，画面也很清晰" },
  { id: 3, user: "战术板", text: "感觉对面接下来要换打法了" },
  { id: 4, user: "路过的观众", text: "第一次来，请问这是哪个频道的直播呀" },
  { id: 5, user: "弹幕小能手", text: "支持主播，已关注" },
  { id: 6, user: "刚枪小萌新", text: "学到了，原来还能这样操作" },
];

export default function DanmakuPanel() {
  const [messages, setMessages] = useState<Message[]>(initialMessages);
  const [text, setText] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const listRef = useRef<HTMLDivElement>(null);
  const seqRef = useRef(100);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [messages, collapsed]);

  const send = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = text.trim();
    if (!value) {
      return;
    }
    seqRef.current += 1;
    setMessages((prev) => [...prev, { id: seqRef.current, user: "我", text: value, self: true }]);
    setText("");
  };

  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-100 lg:h-full">
      <div className="flex items-center justify-between border-b border-background-200/60 px-4 py-3">
        <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-chat-3-line text-primary-300" />
          弹幕聊天室
          <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] font-medium text-foreground-600">
            {messages.length}
          </span>
        </h2>
        <button
          type="button"
          onClick={() => setCollapsed((prev) => !prev)}
          className="flex h-7 w-7 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-200 hover:text-foreground-950"
          aria-label={collapsed ? "展开聊天室" : "收起聊天室"}
        >
          <i className={collapsed ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
        </button>
      </div>

      {!collapsed && (
        <>
          <div ref={listRef} className="no-scrollbar flex max-h-[280px] flex-col gap-3 overflow-y-auto p-4 lg:max-h-none lg:flex-1">
            {messages.map((message) => (
              <div
                key={message.id}
                className={`flex flex-col gap-1 rounded-lg px-3 py-2 text-sm ${
                  message.self ? "bg-primary-500/15" : "bg-background-200/40"
                }`}
              >
                <span className={`text-xs font-medium ${message.self ? "text-primary-300" : "text-secondary-900"}`}>
                  {message.user}
                </span>
                <span className="leading-relaxed text-foreground-800">{message.text}</span>
              </div>
            ))}
          </div>

          <form onSubmit={send} className="border-t border-background-200/60 p-3">
            <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3">
              <input
                value={text}
                onChange={(event) => setText(event.target.value)}
                placeholder="发条弹幕，和大家聊聊…"
                className="h-10 w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
                maxLength={60}
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                发送
              </button>
            </div>
            <p className="mt-2 px-1 text-[11px] text-foreground-500">
              弹幕为前端演示，仅在本页面本地展示，不会真实发送。
            </p>
          </form>
        </>
      )}
    </div>
  );
}